// extracted by mini-css-extract-plugin
export var box = "style-mod--box--1c1af";
export var imgBox = "style-mod--img-box--bd479";
export var imgBoxSelected = "style-mod--img-box-selected--056c2";
export var saleMessage = "style-mod--sale-message--04d68";
export var saleMessageParent = "style-mod--sale-message-parent--34fe2";
export var triangle = "style-mod--triangle--6d59a";
export var variantTitle = "style-mod--variant-title--0082f";